import * as React from "react";
import styled from "styled-components";
import Text from "../Text";
import { select } from "@hubper/theme";
import AddToCheckToggle from "../AddToCheckToggle";
import { Icon } from "..";
import { IconName } from "../Icon";

const TitleIcon = styled(Icon)`
  transform: translateY(-1px);
  margin-left: ${select.space(1)};
`;

const ToggleBoxBase = styled.div`
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  padding: ${select.space(3)} 0 0 ${select.space(3)};
  transition: ${select.speed("fast")};
  position: relative;

  &:not(:last-child) {
    .toggle-box-main {
      border-bottom: 1px solid ${select.color(["grey", 1])};
    }
  }

  &:hover {
    background-color: ${select.color(["grey", 0])};
  }
`;

const ToggleBoxMain = styled.div`
  flex-grow: 1;
  padding-bottom: ${select.space(3)};
  padding-right: 40px;
`;

const ToggleBoxToggle = styled.div`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
`;

const ToggleBoxImage = styled.div`
  width: 30px;
  height: 30px;
  margin-right: ${select.space(2)};
  background-color: ${select.color(["grey", 0])};
  border-radius: 3px;
  flex-shrink: 0;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  title: string;
  description?: string;
  image?: string;
  selected: boolean;
  titleIcon?: IconName;

  onClick: (selected: boolean) => void;
};

function ToggleBox(
  {
    style,
    className,
    title,
    description,
    image,
    selected,
    onClick,
    titleIcon
  }: Props,
  ref: any
) {
  return (
    <ToggleBoxBase
      ref={ref}
      style={style}
      className={className}
      onClick={() => onClick(selected)}
    >
      <ToggleBoxImage>
        {image && <img src={image} alt={title} />}
      </ToggleBoxImage>
      <ToggleBoxMain className="toggle-box-main">
        <Text c={["grey", 9]} fs={0} fw="bold" style={{ display: "block" }}>
          {title}
          {titleIcon && <TitleIcon name={titleIcon} />}
        </Text>
        <Text c={["grey", 5]} fs={-2} fw="bold" style={{ display: "block" }}>
          {description}
        </Text>
      </ToggleBoxMain>
      <ToggleBoxToggle>
        <AddToCheckToggle value={selected} size={20} />
      </ToggleBoxToggle>
    </ToggleBoxBase>
  );
}

export default React.forwardRef(ToggleBox);
